import { useContext, useEffect, useRef } from "react";
import { CInputText, CInputPassword, BtnLoader, PageLoader, toast } from "../../components/widget";
import { useNavigate , Link} from 'react-router-dom';
import { ForgetApi } from "../../api";
import { ContextLoading } from "../../context";

export const Forget = () => {
    const navigate = useNavigate();
    const formRef: any = useRef()
    const CtxLoad = useContext(ContextLoading)

    const handelForget = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res:any = await ForgetApi(formRef)
        CtxLoad.setDisplayLoadingBtn(false)   
        if (res.data.success) {
            toast("درخواست بازیابی رمز عبور به ایمیل شما ارسال شد", { type: "success" })
            navigate('/');
        }
        else {
            toast(res.data.message, { type: "error" })
        }
    }

    useEffect(()=>{
        document.title = "فراموشی رمز عبور | دایان"
    },[])

    return (
        <>
            {CtxLoad.displayLoading && <PageLoader />}
            <div className=" w-full min-h-screen bg-dayan-gray-50 flex justify-center items-center">
                <div className="w-full sm:w-[400px]  flex flex-col items-center">
                    <img src="/assetes/logo/logo.png" alt="logo" className=" w-[120px]" />
                    <div className=" w-[94%] sm:w-full mt-[10px] flex flex-col items-center justify-center rounded-xl shadow bg-white py-[30px] px-[20px]">
                        <form ref={formRef} onSubmit={handelForget} className=" w-full ">
                            <CInputText custom_class="Cltr" name="email" title="پست الکترونیکی" type="email" required={true} />
                            {CtxLoad.displayLoadingBtn ?
                                <button type="button" className=" w-full h-[40px] sm:h-[45px] text-white text-xs font-bold rounded-[5px] bg-dayan-gray-100 flex justify-center items-center cursor-not-allowed"><BtnLoader /></button>
                                :
                                <button type="submit" className=" w-full h-[40px] sm:h-[45px] text-white text-xs font-bold rounded-[5px] bg-dayan-gray-100">تایید</button>
                            }
                        </form>
                        <Link to={'/'} className="mt-[20px]">
                            <span className=" text-dayan-gray-100 text-xs cursor-pointer ">بازگشت</span>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
